import { createContext } from 'react';

export interface IFlowContext {
    changeActiveStep: (step: string) => void;
    changeMoneyMovementMode: (mode: boolean) => void;
    moneyMovementMode: boolean;
    isSavingsBucket: boolean;
}

export const FlowContext = createContext<IFlowContext>(
  {
    changeActiveStep: (step) => {
      console.log(step);
    },
    changeMoneyMovementMode: (mode) => {
      console.log(mode);
    },
    moneyMovementMode: false,
    isSavingsBucket: false,
  },
);
